import { loadScript } from 'util/loadScript';

const SCRIPT_ID = 'gmapsApi';
const CALLBACK = 'googleMapsReady';

let mapsApiLoadingPromise;

export function loadMapsApi() {
    if (mapsApiLoadingPromise) return mapsApiLoadingPromise;

    mapsApiLoadingPromise = new Promise((resolve) => {
        const url = `//maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_KEY}&language=de&callback=${CALLBACK}`;
        loadScript(url, SCRIPT_ID);
        window.googleMapsReady = () => resolve();
    });

    return mapsApiLoadingPromise;
}
